import { render } from "./NovelTitle.vue?vue&type=template&id=08b5d86a&scoped=true&ts=true"
import script from "./NovelTitle.vue?vue&type=script&lang=ts"
export * from "./NovelTitle.vue?vue&type=script&lang=ts"

import "./NovelTitle.vue?vue&type=style&index=0&id=08b5d86a&scoped=true&lang=scss"

import exportComponent from "/builds/web-primary/web-novel-stores/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b5d86a"]])

export default __exports__